import { createBrowserRouter } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import Login from "../pages/login/Login";
import NotAuthorized from "../pages/not-authorized/NotAuthorized";
import Dashboard from "../pages/dashboard/Dashboard";
import PromptLibrary from "../pages/prompt/PromptLibrary";
import RunDocument from "../pages/prompt/RunDocument";
import PrivilegeRoute from "./PrivilegeRoute";
import { Privilege } from "../config/constants/privilege";
import UserManagement from "../pages/user-management/UserManagement";
import ValidationLibrary from "../pages/validation-rule/ValidationLibrary";
import ProjectManagement from "../pages/project-management/ProjectManagement";
import SmartPrompt from "../pages/smart-prompt/SmartPrompt";
import NotFound from "../pages/not-found/NotFound";
import Chat from "../pages/chat/Chat";
import UserActivityLog from "../pages/user-activity-log/UserActivityLog";
import MultiRunPrompt from "../pages/prompt/MultiRunPrompt";

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <Login />
    },
    {
      path: "",
      element: <PrivateRoute />,
      children: [
        {
          path: "*",
          element: <NotFound />
        },
        {
          path: "not-authorized",
          element: <NotAuthorized />
        },
        {
          path: "dashboard",
          element: <Dashboard />
        },
        {
          path: "prompt",
          element: <PromptLibrary />
        },
        {
          path: "validationrule",
          element: <ValidationLibrary />
        },
        {
          path: "rundocument",
          element: <RunDocument />
        },
        {
          path: "multi-run-prompt",
          element: <MultiRunPrompt />
        },
        {
          path: "usermanagement",
          element: <PrivilegeRoute component={<UserManagement />} privilege={Privilege[Privilege.USER_MANAGEMENT]} />
        },
        {
          path: "useractivitylog",
          element: <PrivilegeRoute component={<UserActivityLog />} privilege={Privilege[Privilege.USER_MANAGEMENT]} />
        },
        {
          path: "projectmanagement",
          element: <PrivilegeRoute component={<ProjectManagement />} privilege={Privilege[Privilege.VIEW_PROJECT_MANAGEMENT]} />
        },
        /* {
          path: "changepassword",
          element: <ChangePassword />
        }, */
        {
          path: "smartprompt",
          element: <SmartPrompt />
        },
        {
          path: "chat",
          element: <Chat />
        }
      ],
    },
  ],
  { basename: process.env.PUBLIC_URL },
)
export default router
